import { Configuration, LogLevel } from '@azure/msal-browser'

const getClientId = (): string => {
  const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || null
  if (!clientId) {
    throw new Error("Missing environment variable: REACT_APP_AZURE_CLIENT_ID")
  }
  return clientId
}

const getRedirectUri = (): string => {
  const redirectUri = process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000/'
  if (!redirectUri) {
    throw new Error("Missing environment variable: REACT_APP_REDIRECT_URI")
  }
  return redirectUri
}

const getAuthority = (): string => {
  const tenantId = process.env.REACT_APP_AZURE_TENANT_ID
  if (!tenantId) {
    throw new Error("Missing environment variable: REACT_APP_AZURE_TENANT_ID")
  }
  return `https://login.microsoftonline.com/${tenantId}`
}

export const msalConfig: Configuration = {
  auth: {
    clientId: getClientId(),
    redirectUri: getRedirectUri(),
    authority: getAuthority(),
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    tokenRenewalOffsetSeconds: 300,
    allowRedirectInIframe: false,
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        switch (logLevel) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
          default:
            return
        }
      },
    },
  },
}
